document.addEventListener("DOMContentLoaded", function() {
    // Delay the execution by 1 second (1000 milliseconds)
    setTimeout(function() {
        console.log("1 second delay completed");

        // Check if the specified element exists
        var targetElement = document.querySelector('div[data-product-blocks] > .variant-swatch-king .swatches div[option-name="Color"]');
        if (targetElement) {
            console.log("Target element found:", targetElement);
            // Add the 'active-cls' class to the body element
            document.body.classList.add('active-cls');
            console.log(".active-cls class added to body");
        } else {
            console.log("Target element not found");
        }
    }, 2000);
});

document.addEventListener('DOMContentLoaded', function () {
    var tabLinks = document.querySelectorAll('.tab-link');
    var tabContents = document.querySelectorAll('.tab-content');

    tabLinks.forEach(function (tabLink) {
        tabLink.addEventListener('click', function () {
            var tabName = this.getAttribute('data-tab');

            // Hide all tab contents
            tabContents.forEach(function (tabContent) {
                tabContent.style.display = 'none';
                tabContent.classList.remove('active');
            });

            // Remove active class from all tab links
            tabLinks.forEach(function (link) {
                link.classList.remove('active');
            });

            // Show the current tab, and add an "active" class to the button that opened the tab
            var activeTab = document.getElementById(tabName);
            activeTab.style.display = 'block';
            activeTab.classList.add('active');
            this.classList.add('active');

            // Reinitialize Slick Slider
            $(activeTab).find('.slick-slider').slick('setPosition');
        });
    });

    // Activate the first tab by default
    tabLinks[0].click();
});

     // document.addEventListener("DOMContentLoaded", function() {
     //        setTimeout(function() {
     //            var sizeChart = document.querySelector(".size-chart__standalone");
     //            var swatchLabelButton = document.querySelector(".swatch-label.swatch-label-button");

     //            if (sizeChart && swatchLabelButton) {
     //                var sizeChartClone = sizeChart.cloneNode(true);
     //                swatchLabelButton.appendChild(sizeChartClone);
     //            }
     //        }, 2000);
     //    });